import ReactDom from "react-dom";
import { App } from "./App";

const globalConfigUrl = "configs/config.json";

declare global {
  let GLOBAL_CONFIG: GlobalConfigDefinition;
}

const AppConfig = async () => {
  let errorStatusCode = "";
  let hasError = false;
  const fetchConfigData = async () => {
    const responseConfig = await fetch(globalConfigUrl, { cache: "no-store" })
      .then(async response => {
        return (await response.json()) as GlobalConfigDefinition;
      })
      .catch(() => {
        errorStatusCode = `${globalConfigUrl} not found`;
        hasError = true;
        return null;
      });
    if (!responseConfig) {
      return;
    }
    GLOBAL_CONFIG = { GLOBAL_CONFIG, ...responseConfig };
  };

  await fetchConfigData();

  return { errorStatusCode, hasError };
};

const app = document.getElementById("app");

AppConfig();

AppConfig().then(appConfig => {
  ReactDom.render(<App />, app);
});
